export default {
  init() {
  },
  finalize() {
    const insuranceOptionAreas = document.querySelectorAll('.js-insurance-option');
    const alternateInsuranceOptionAreas = document.querySelectorAll('.js-insurance-option-alt');
    const learnMoreButtons = document.querySelectorAll('.js-insurance-learn-more');
    const insuranceInfoLightbox = document.querySelector('.insurance-info-lightbox');
    const insuranceLightboxSections = document.querySelectorAll('.insurance-lightbox-section');

    // Called whether the div or learnmore button is clicked
    const insuranceEvent = (e, domElement) => {
      e.preventDefault();

      insuranceOptionAreas.forEach(
        (domElement) => {
          domElement.querySelector('.insurance-body').classList.remove('insurance-body-enabled')
          domElement.classList.remove('insurance-option-enabled');
        });

      domElement.classList.add('insurance-option-enabled');

      domElement.querySelector('.insurance-body').classList.toggle('insurance-body-enabled');

      insuranceInfoLightbox.classList.add('insurance-info-lightbox-enabled');

      insuranceLightboxSections.forEach((section) => { section.classList.remove('insurance-lightbox-section-enabled') });

      insuranceInfoLightbox.querySelector(`[data-category="${domElement.dataset.category}"]`).classList.add('insurance-lightbox-section-enabled');
    }

    const altInsuranceEvent = (e, domElement) => {
      insuranceOptionAreas.forEach(
        (domElement) => {
          domElement.querySelector('.insurance-body').classList.remove('insurance-body-enabled')
          domElement.classList.remove('insurance-option-enabled');
        });

      domElement.classList.add('insurance-option-enabled');

      domElement.querySelector('.insurance-body').classList.toggle('insurance-body-enabled');

      insuranceInfoLightbox.classList.remove('insurance-info-lightbox-enabled');

      insuranceLightboxSections.forEach((section) => { section.classList.remove('insurance-lightbox-section-enabled') });
    }

    insuranceOptionAreas.forEach(
      (domElement) => {
        domElement.addEventListener('click', (e) => { insuranceEvent(e, domElement) }, false);
      }
    );

    alternateInsuranceOptionAreas.forEach(
      (domElement) => {
        domElement.addEventListener('click', (e) => { altInsuranceEvent(e, domElement) }, false);
      }
    );

    learnMoreButtons.forEach(
      (button) => {
        button.addEventListener('click', (e) => {
          console.log(button.parentNode.parentNode);

          insuranceEvent(e, button.parentNode.parentNode);

          insuranceInfoLightbox.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
        }, false);
      }
    )

    // Custom Footer Nav Jumps
    const areaId = window.location.href.split('#')[1];
    const areaSelected = document.getElementById(`insurance-${areaId}`);

    if (areaId !== undefined && areaSelected !== null) {
      areaSelected.scrollIntoView();
      areaSelected.click();
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/insurance.js